import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { getStr } from "../creator/utils/simpleLocalisation";


export class gameShed extends cDisplay {

  private code: string[] = ['0','0','0']
  private correct:string[] = ["urne","stifte","sichtschutz","musterbogen","tisch","stuhl"]
  private collected:string[] = []
  private score:number = 4
  private textData:any

  private dropArea: any

  init(){
    super.init()
    console.log('GAME gameShed')

    this.collected = []
    var cS:cScene = this.scene as cScene;  
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      
      switch (b.command){
        case 'check_completed':
          if (this.collected.length == this.correct.length){
            cS.triggerSceneEvent('completed',{
              type:'utilities',
              score:this.score
            });
            var holder:Phaser.GameObjects.Container = this.getByName('item_holder')
            holder.getAll().forEach( (el:any )=>{
              (el as cSprite).modules.drag.enabled = false
            })
          }
          break;
        case 'handle_startdrag':
          // var r = this.getByName( b.payload.drag )
          // console.log('STARTDRAH', b,r.depth)
          this.dropArea.alpha = 0.8
          break;
        case 'handle_drop':
          this.dropArea.alpha = 0
          if (b.payload.tg === null) return
          
          var nm = b.payload.drag
          console.log('>>',nm)
          if (this.correct.indexOf(nm) !== -1){
            if (this.collected.indexOf(nm) === -1){
              this.collected.push(nm);
              (this.getByName(nm) as cSprite).visible = false
            }
          }else{
            this.score -= this.score > 1 ? 1 : 0;
            (this.getByName(nm) as cSprite).modules.drag.returnToOrigin()
          }

          var bItem = this.getByName('inhalt_'+nm)
          if (bItem) bItem.visible = 1

          cS.triggerSceneEvent('result',{
            "title": getStr(this.textData[nm][0]),
            "info": getStr(this.textData[nm][1])
          });

          break;
      }
    })
  }

  buildScene(){    
    var cS:cScene = this.scene as cScene;    
    super.buildScene();

    this.textData = (this.getByName('DATA') as cSprite).modules.data._extraData
    console.log(this.textData)

    this.dropArea = this.getByName('droparea')

  }



}
